import { render } from "./operateWork.vue?vue&type=template&id=0d13d24c&scoped=true"
import script from "./operateWork.vue?vue&type=script&lang=js"
export * from "./operateWork.vue?vue&type=script&lang=js"

import "./operateWork.vue?vue&type=style&index=0&id=0d13d24c&lang=scss&scoped=true"
import "./operateWork.vue?vue&type=style&index=1&id=0d13d24c&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d13d24c"]])

export default __exports__